"use strict";

import { combineEpics } from "redux-observable";

import {
    homeGetRealTimeRewardCodeEpic,
    homeGetRealTimeRewardReasonListEpic,
    homeGetParticipantListEpic,
    homeSmsRealTimeRewardCodeEpic,
    homeCampaignListEpic,
    homeGetRealTimeRewardCampaignEpic,
    homeGetChatBotReplyQuestionEpic,
    homeGetChatbotFaqQuestionsEpic,
    getParticipantJobRoleEpic,
    getDealerParticipantListEpic,
    registerDealerParticipantEpic,
    requestActivateAccountEpic,
    updateDealerParticipantStatusEpic,
    removeDealerParticipantEpic,
    homeUserLoginStatusEpic,
    getTeamGamePlayDetailsEpic,
    homeSendGamePlayCodeEpic,
    homeResetGamePlayCodeEpic,
    homeGetNotificationEpic,
    homeDeleteNotificationEpic,
    homeGetNotificationCountEpic,
} from "./home.epics";

import {
    getKnowlegeLatestQuizzesEpic,
    getKnowlegeDasboardEpic,
    getKnowlegeParticipantQuizzesEpic,
    getKnowlegeQuizzDetailsEpic,
    knowlegeAnswerQuestionEpic,
    knowlegeEnrolQuizzEpic,
    knowlegeQuestioResultEpic,
} from "./knowledge.epics";

import {
    getShopFavouritesEpic,
    getShopTopPicksEpic,
    getShopTrendingsEpic,
    getShopVoucherDetailsEpic,
    getShopVoucherWalletEpic,
    getShopOrderDetailsEpic,
    shopConfirmOrderEpic,
    getShopBrowserProductsEpic,
    getShopPopularFilterEpic,
    getShopCategoryEpic,
    shopBuyPointsEpic,
    setVoucherRedeemStatusEpic,
    shopRateVoucherEpic,
    shopTLCGetPointBalanceEpic,
    shopTLCRebatePointsEpic,
} from "./shop.epic";

import {
    loginAuthEpic,
    logoutAuthEpic,
    authUserProfileDetailsEpic,
    getNewActionTokenEpic,
    reRegistrationEpic,
    preRegistrationActivateEpic,
    forgotPasswordEmailVeryficationEpic,
    forgotPasswordResetPasswordEpic,
    sendOptEpic,
    reSendOptEpic,
    changePasswordEpic,
    changeMobileNumberEpic,
    sendOTPAfterLoginEpic,
    profilePictureUploadEpic,
    profileNotificationChangeEpic,
    profileChangeHomeAddressEpic,
    changeProfileNameEpic,
    getUserDetailsEpic,
    getParticipantProfileEpic,
    subscribeEpic,
    userDeviceEpic,
} from "./auth.epics";

import {
    getUserAchievementsEpic,
    getUserThingsToDoEpic,
    getUserMembershipEpic,
    getUserPointsTransactionsEpic,
    getUserGoalsEpic,
    getUserIncentiveHistoryEpic,
    getParticipantNotificationEpic,
    getNewsFeedEpic,
    readNotificationEpic,
    getUserPointsBalanceEpic,
    getLatestTransactionEpic,
    userAccountLogUserLogStatusEpic,
} from "./user.epics";

import {
    getLatestCampaignEpic,
    getHomeCarouselCampaignEpic,
    getHomeGetBestVoucherDealsTodayEpic,
    getHomeGetTrendingVouchersEpic,
    getFeaturedCampaignBannersEpic,
    getHomeGetCampaignDetailsEpic,
    campaignTokenValidationEpic,
    campaignSpinwingetDataEpic,
    campaignSpinwingetInitialDataEpic,
    joinIncentiveDataEpic,
    getCampaignHomeBannersEpic,
    getCampaignVoucherAddToFavouriteEpic,
    getCampaignVoucherRemoveFromFavouriteEpic,
    getCampaignLeagueTableEpic,
    getParticipantSalesEpic,
    campaignPrizeDrawDetailsEpic,
    addPrizeDrawCampaignEntryDataEpic,
    getLeagueTeamDetailsEpic,
    getLeagueIndividualDetailsEpic,
    submitLeagueTeamParticipantEpic,
    getCommsDetailsEpic,
    campaignGetWareAndTireSummaryEpic,
    campaignGetLeagueTableSummaryEpic,
    campaignGetParticipantIncentiveEpic,
    campaignGetParticipantIncentiveCampaignPerformanceMetricsEpic,
    campaignGetCastrolLeagueTableSummaryEpic,
    campaignPageLogPageViewEpic,
    campaignLikeContentPageEpic,
    campaignLikeSummaryEpic,
    campaignGetAreaManagerDealersEpic,
    campaignGetParticipantsByDealerEpic,
    campaignGetPerformanceMetricsByDealerEpic,
    campaignGetAreaManagersLeaguesRankSummaryEpic,
    campaignGetCastrolLeagueQ4TableSummaryEpic,
    campaignGetServiceManagersLeaguesBonusBrakePadsRankSummaryEpic,
    campaignGetServiceManagersLeaguesBonusRankWiperBladeSummaryEpic,
    campaignGetServiceManagersLeaguesBonusRankBrakeDiscsSummaryEpic,
    campaignGetServiceManagersLeaguesBonusRankAreaTopPerformerSummaryEpic,
    campaignGetServiceManagersLeaguesBonusBatteryRankSummaryEpic,
    campaignGetLeagueNationalTopPerformerSummaryEpic,
    getTlcCustomerEpic,
    getGoldRushCampaignPerformanceSummaryEpic,
    getCastrolDealerPerformanceSummaryEpic,
    campaignGetPerformanceMetricsByDealerDropDownEpic,
    campaignGetServiceManagersLeaguesBonusBatteryRankSummaryDropDownEpic,
    campaignGetLeagueNationalTopPerformerSummaryDropDownEpic,
    campaignGetLeagueTableSummaryDropDownEpic,
    campaignGetTlcRetailersEpic,
    campaignGetWearAndTearTeamPerformanceSummaryEpic,
    campaignGetServiceStartLeagueRankSummaryEpic,
    campaignGetWinningSpinDataEpic,
    campaignGetAlpineRewardSummaryEpic,
    campaignGetTradePartsManagerSalesSummaryEpic,
    campaignGetCastrolMotoLeaguesRankSummaryEpic,
    campaignGetTLCCustomerByDealersEpic,
    campaignGetFullThrottleLeagueRankSummaryEpic,
    campaignGoldenTicketScratchCardDataEpic,
    campaignGoldenTicketClaimScratchCardCodeEpic,
    campaignVoteRewardPreferencesEpic,
    campaignGetAllAreaManagerDealersEpic,
    campaignGetRewardAndRecognitionTeamMateEpic,
    campaignGetRewardAndRecognitionNominationReasonEpic,
    campaignPostRewardAndRecognitionNominationSendEpic,
    campaignGetRewardAndRecognitionGetParticipantPostsEpic,
    campaignGetRewardAndRecognitionGetAiParaphraseEpic,
    campaignPostRewardAndRecognitionRewardNominationCommentsEpic,
    campaignPostRewardAndRecognitionLikeRewardPostEpic,
} from "./campiagn.epics";
import { imageUploadCommonEpic } from "./common.epic";

export default combineEpics(
    loginAuthEpic,
    logoutAuthEpic,
    getNewActionTokenEpic,
    reRegistrationEpic,
    preRegistrationActivateEpic,
    forgotPasswordEmailVeryficationEpic,
    forgotPasswordResetPasswordEpic,
    sendOptEpic,
    reSendOptEpic,
    changePasswordEpic,
    sendOTPAfterLoginEpic,
    changeMobileNumberEpic,
    profilePictureUploadEpic,
    profileNotificationChangeEpic,
    profileChangeHomeAddressEpic,
    changeProfileNameEpic,
    getUserDetailsEpic,
    getParticipantProfileEpic,
    subscribeEpic,
    userDeviceEpic,
    homeUserLoginStatusEpic,
    userAccountLogUserLogStatusEpic,

    authUserProfileDetailsEpic,
    getLatestCampaignEpic,
    getFeaturedCampaignBannersEpic,
    getHomeGetCampaignDetailsEpic,
    campaignTokenValidationEpic,
    campaignSpinwingetDataEpic,
    campaignSpinwingetInitialDataEpic,
    joinIncentiveDataEpic,
    getCampaignHomeBannersEpic,
    getCampaignVoucherAddToFavouriteEpic,
    getCampaignVoucherRemoveFromFavouriteEpic,
    getCampaignLeagueTableEpic,
    getParticipantSalesEpic,
    campaignPrizeDrawDetailsEpic,
    addPrizeDrawCampaignEntryDataEpic,
    getLeagueTeamDetailsEpic,
    getLeagueIndividualDetailsEpic,
    submitLeagueTeamParticipantEpic,
    getCommsDetailsEpic,
    campaignGetWareAndTireSummaryEpic,
    campaignGetLeagueTableSummaryEpic,
    campaignGetParticipantIncentiveEpic,
    campaignGetParticipantIncentiveCampaignPerformanceMetricsEpic,
    campaignGetCastrolLeagueTableSummaryEpic,
    campaignPageLogPageViewEpic,
    campaignLikeContentPageEpic,
    campaignLikeSummaryEpic,
    campaignGetAreaManagerDealersEpic,
    campaignGetParticipantsByDealerEpic,
    campaignGetPerformanceMetricsByDealerEpic,
    campaignGetAreaManagersLeaguesRankSummaryEpic,
    campaignGetCastrolLeagueQ4TableSummaryEpic,
    campaignGetServiceManagersLeaguesBonusBrakePadsRankSummaryEpic,
    campaignGetServiceManagersLeaguesBonusRankWiperBladeSummaryEpic,
    campaignGetServiceManagersLeaguesBonusRankBrakeDiscsSummaryEpic,
    campaignGetServiceManagersLeaguesBonusRankAreaTopPerformerSummaryEpic,
    campaignGetServiceManagersLeaguesBonusBatteryRankSummaryEpic,
    campaignGetLeagueNationalTopPerformerSummaryEpic,
    campaignGetPerformanceMetricsByDealerDropDownEpic,
    campaignGetServiceManagersLeaguesBonusBatteryRankSummaryDropDownEpic,
    campaignGetLeagueNationalTopPerformerSummaryDropDownEpic,
    getTlcCustomerEpic,
    getGoldRushCampaignPerformanceSummaryEpic,
    getCastrolDealerPerformanceSummaryEpic,
    campaignGetLeagueTableSummaryDropDownEpic,
    campaignGetTlcRetailersEpic,
    campaignGetWearAndTearTeamPerformanceSummaryEpic,
    campaignGetServiceStartLeagueRankSummaryEpic,
    campaignGetWinningSpinDataEpic,
    campaignGetAlpineRewardSummaryEpic,
    campaignGetTradePartsManagerSalesSummaryEpic,
    campaignGetCastrolMotoLeaguesRankSummaryEpic,
    campaignGetTLCCustomerByDealersEpic,
    campaignGetFullThrottleLeagueRankSummaryEpic,
    campaignGoldenTicketScratchCardDataEpic,
    campaignGoldenTicketClaimScratchCardCodeEpic,
    campaignVoteRewardPreferencesEpic,
    campaignGetAllAreaManagerDealersEpic,
    campaignGetRewardAndRecognitionTeamMateEpic,
    campaignGetRewardAndRecognitionNominationReasonEpic,
    campaignPostRewardAndRecognitionNominationSendEpic,
    campaignGetRewardAndRecognitionGetParticipantPostsEpic,
    campaignGetRewardAndRecognitionGetAiParaphraseEpic,
    campaignPostRewardAndRecognitionRewardNominationCommentsEpic,
    campaignPostRewardAndRecognitionLikeRewardPostEpic,

    getUserAchievementsEpic,
    getUserThingsToDoEpic,
    getUserMembershipEpic,
    getUserPointsTransactionsEpic,
    getUserGoalsEpic,
    getUserIncentiveHistoryEpic,
    getParticipantNotificationEpic,
    getNewsFeedEpic,
    readNotificationEpic,
    getUserPointsBalanceEpic,
    getLatestTransactionEpic,

    getHomeCarouselCampaignEpic,
    getHomeGetBestVoucherDealsTodayEpic,
    getHomeGetTrendingVouchersEpic,

    getShopFavouritesEpic,
    getShopTopPicksEpic,
    getShopTrendingsEpic,
    getShopVoucherDetailsEpic,
    getShopVoucherWalletEpic,
    getShopOrderDetailsEpic,
    shopConfirmOrderEpic,
    getShopBrowserProductsEpic,
    getShopPopularFilterEpic,
    getShopCategoryEpic,
    shopBuyPointsEpic,
    setVoucherRedeemStatusEpic,
    shopRateVoucherEpic,
    shopTLCGetPointBalanceEpic,
    shopTLCRebatePointsEpic,

    getKnowlegeLatestQuizzesEpic,
    getKnowlegeDasboardEpic,
    getKnowlegeParticipantQuizzesEpic,
    getKnowlegeQuizzDetailsEpic,
    knowlegeAnswerQuestionEpic,
    knowlegeEnrolQuizzEpic,
    knowlegeQuestioResultEpic,

    homeGetRealTimeRewardCodeEpic,
    homeGetRealTimeRewardReasonListEpic,
    homeGetParticipantListEpic,
    homeSmsRealTimeRewardCodeEpic,
    homeCampaignListEpic,
    homeGetRealTimeRewardCampaignEpic,
    getTeamGamePlayDetailsEpic,
    homeSendGamePlayCodeEpic,
    homeResetGamePlayCodeEpic,
    homeGetNotificationEpic,
    homeDeleteNotificationEpic,
    homeGetNotificationCountEpic,

    imageUploadCommonEpic,
    homeGetChatBotReplyQuestionEpic,
    homeGetChatbotFaqQuestionsEpic,
    getParticipantJobRoleEpic,
    getDealerParticipantListEpic,
    registerDealerParticipantEpic,

    updateDealerParticipantStatusEpic,
    removeDealerParticipantEpic,
    requestActivateAccountEpic,
);
